import { hasValue } from '@famly/stat_ts-utils_has-value';
import { readServerErrorBody } from './read-server-error-body';
/**
 * The failed request's body when it is a JSON object, or `null` for any other body.
 */
export const readServerErrorObject = (error) => {
    const body = readServerErrorBody(error);
    return hasValue(body) && typeof body === 'object' ? body : null;
};
